"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("../core");
exports.BackIcon = function (props) {
    return (react_1.default.createElement(core_1.Icon, null,
        react_1.default.createElement("svg", { width: "31px", height: "31px", viewBox: "0 0 31 31", version: "1.1" },
            react_1.default.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                react_1.default.createElement("g", { transform: "translate(-235.000000, -232.000000)" },
                    react_1.default.createElement("g", { transform: "translate(235.000000, 232.000000)" },
                        react_1.default.createElement("circle", { fill: "#ECEDF0", cx: "15.5", cy: "15.5", r: "15.5" }),
                        react_1.default.createElement("polyline", { stroke: "#525456", strokeWidth: "2", transform: "translate(15.000000, 15.500000) rotate(-270.000000) translate(-15.000000, -15.500000) ", points: "21 13 15 18 9 13" })))))));
};
